import axios from "axios";
// import { returnErrors } from "./errorActions";
import i18n from "./../components/helper/i18n";

import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  REGISTER_SUCCESS,
  // REGISTER_FAIL,
  REGISTER_NOTIFICATION,
  REGISTER_ERROR,
  LOGOUT_SUCCESS,
  LOGIN_SUCCESS,
  // LOGIN_FAIL,
  LOGIN_ERROR,
  LOGIN_NOTIFICATION,
  FIRST_CONNECTION,
  VALIDATE_EMAIL,
  EMAIL_VALIDATION_SUCCESS,
  EMAIL_VALIDATION_FAIL,
  RESEND_EMAIL_VALIDATION,
  RESET_AUTH_USER,
  USER_UPDATED,
  ADMIN_FUNCTION,
  ACCEPT_COOKIES,
  RESET_PWD_USER,
  REMOVE_GREETINGS,
  ITEM_LOCK,
} from "./types";
import configData from "./../configData";

// import { useHistory } from "react-router-dom";

// // import { getElements } from "./elementActions";
// // import PropTypes from "prop-types";
// // import { connect } from "react-redux";
// // import CallGetElements from "./CallGetElements";
// // Check token & load user

// export const updateLang = (lang) => (dispatch) => {
//   // let propTypes = {
//     dispatch({ type: UPDATE_LANGUAGE,data:lang });
// }

export const acceptCookies = (tf) => (dispatch, getState) => {
  // console.log("checkauthentification action called");
  dispatch({ type: ACCEPT_COOKIES, payload: tf });
};

export const removeGreetings = (tf) => (dispatch, getState) => {
  // console.log("checkauthentification action called");
  dispatch({ type: REMOVE_GREETINGS });
};

export const resetAuthUser = () => (dispatch, getState) => {
  // console.log("checkauthentification action called");
  dispatch({ type: RESET_AUTH_USER });
};

export const checkAuthentification = () => (dispatch, getState) => {
  // console.log("checkauthentification action called");
  dispatch({ type: FIRST_CONNECTION });
};

export const resetPwd = (info) => (dispatch, getState) => {
  // console.log("resetPwd", info);
  dispatch({
    type: LOGIN_NOTIFICATION,
    payload: "Loading...",
  });
  // setTimeout(() => {
  //   dispatch({
  //     type: LOGIN_NOTIFICATION,
  //     payload: "",
  //   });
  // }, 10000);

  // console.log("reset pwd", info);
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  // const body = JSON.stringify({
  //   email: info.email,
  //   name: info.name,
  //   subdomain: info.subdomain,
  //   language: info.language,
  // });

  axios
    .post(`${configData.SERVER_URL}resetPwd`, info, config)
    // .post("/api/auth", body, config)
    .then(
      (res) => {
        // console.log("login success 0", res.data);

        dispatch({
          type: LOGIN_NOTIFICATION,
          payload: res.data.res,
        });
        // setTimeout(() => {
        //   dispatch({
        //     type: LOGIN_NOTIFICATION,
        //     payload: "",
        //   });
        // }, 10000);
      }
      // (CallGetElements())}
      // dispatch(getElements)
      // this.props.getElements()
    )
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.status);
        console.log(error.response.headers);
        console.log(error.response.data);
        dispatch({
          type: LOGIN_NOTIFICATION,
          payload: "",
        });
        dispatch({
          type: LOGIN_ERROR,
          payload: error.response.data.res,
        });

        setTimeout(() => {
          dispatch({
            type: LOGIN_ERROR,
            payload: "",
          });
        }, 5000);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

export const loadUser = () => (dispatch, getState) => {
  // User loading
  dispatch({ type: USER_LOADING });
  // console.log("logUSer", getState);
  //axios is a http client
  if (!getState || getState === undefined) {
    axios
      .get(`${configData.SERVER_URL}users`, tokenConfig(getState))
      .then((res) =>
        dispatch({
          type: USER_LOADED,
          payload: res.data,
        })
      )
      .catch((error) => {
        // dispatch(returnErrors(err.response.data, err.response.satus));
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);

          console.log(error.response.status);
          console.log(error.response.headers);
          if (error.response.data)
            if (error.response.data.res)
              if (
                error.response.data.res.includes("err token or user undefined")
              ) {
                console.log("error", error.response);
                dispatch({
                  type: LOGOUT_SUCCESS,
                });
              }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        dispatch({
          type: AUTH_ERROR,
        });
      });
  }
};

export const validateEmail =
  ({ email, emailVerificationCode, subdomain }) =>
  (dispatch) => {
    // User loading
    dispatch({ type: VALIDATE_EMAIL });
    // console.log("validate Email action called");

    // header
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // console.log("register");
    const body = JSON.stringify({ email, emailVerificationCode, subdomain });
    //create Request body
    // const body = JSON.stringify({ name, email, password });
    //javascript object and turn it into JSON
    // name email password are passed in by calling register
    axios
      .post(`${configData.SERVER_URL}emailValidation`, body, config)
      .then((res) =>
        dispatch({
          type: EMAIL_VALIDATION_SUCCESS,
        })
      )
      .catch((err) => {
        // dispatch(
        //   returnErrors(err.response.data, err.response.satus, "REGISTER_FAIL")
        // );
        dispatch({
          type: EMAIL_VALIDATION_FAIL,
        });
        console.log("error response email validation", err.response);
      });
  };

//create Register user
export const register =
  ({
    email,
    password,
    language,
    admin,
    firstName,
    lastName,
    newAccounts,
    accessToken = false,
    idToken = false,
    host = false,
    // subject,
    // massage,
  }) =>
  (dispatch, getState) => {
    // User loading
    dispatch({
      type: REGISTER_NOTIFICATION,
      payload: "Loading...",
    });
    setTimeout(() => {
      dispatch({
        type: REGISTER_NOTIFICATION,
        payload: "",
      });
    }, 10000);

    // header
    let config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (admin) {
      config = tokenConfig(getState);
    }
    // console.log("register");
    //create Request body
    // console.log("accessTokk0", accessToken);
    const body = JSON.stringify({
      email,
      password,
      language,
      admin,
      firstName,
      lastName,
      newAccounts,
      accessToken,
      idToken,
      host,
      // subject,
      // massage,
    });
    console.log("register action", email, admin);
    //javascript object and turn it into JSON
    // name email password are passed in by calling register
    axios
      .post(`${configData.SERVER_URL}users`, body, config)
      .then((res) => {
        console.log("reg res", res.data);
        if (admin) {
          dispatch({
            type: REGISTER_NOTIFICATION,
            payload: res.data.res,
          });
          dispatch({
            type: ADMIN_FUNCTION,
            payload: res.data,
          });
        } else {
          console.log("register success");
          dispatch({
            type: REGISTER_SUCCESS,
            payload: res.data.user,
          });
        }
        // setTimeout(() => {
        dispatch({
          type: REGISTER_ERROR,
          payload: "",
        });
        // }, 10000);
        setTimeout(() => {
          dispatch({
            type: REGISTER_NOTIFICATION,
            payload: "",
          });
        }, 10000);
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.status);
          console.log(error.response.headers);
          console.log(error.response.data);
          dispatch({
            type: REGISTER_NOTIFICATION,
            payload: "",
          });
          dispatch({
            type: REGISTER_ERROR,
            payload: error.response.data.res,
          });
          setTimeout(() => {
            dispatch({
              type: REGISTER_ERROR,
              payload: "",
            });
          }, 10000);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  };

export const resendEmailValidation =
  ({ email, language }) =>
  (dispatch) => {
    // console.log("resendEmailValidation called");
    dispatch({
      type: REGISTER_NOTIFICATION,
      payload: "Sending...",
    });
    setTimeout(() => {
      dispatch({
        type: REGISTER_NOTIFICATION,
        payload: "",
      });
    }, 5000);
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({ email, language });

    axios
      .post(`${configData.SERVER_URL}resendEmailValidation`, body, config)
      .then((res) => {
        dispatch({
          type: RESEND_EMAIL_VALIDATION,
        });
        dispatch({
          type: REGISTER_NOTIFICATION,
          payload: "Validation email sent.",
        });
        setTimeout(() => {
          dispatch({
            type: REGISTER_NOTIFICATION,
            payload: "",
          });
        }, 2000);
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.status);
          console.log(error.response.headers);
          console.log(error.response.data);
          dispatch({
            type: REGISTER_NOTIFICATION,
            payload: "",
          });
          dispatch({
            type: REGISTER_ERROR,
            payload: error.response.data.res,
          });
          setTimeout(() => {
            dispatch({
              type: REGISTER_ERROR,
              payload: "",
            });
          }, 5000);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  };

export const resetValidationPwd = (info) => (dispatch) => {
  // console.log("resetValidationPwd", info);
  dispatch({
    type: LOGIN_NOTIFICATION,
    payload: "Loading...",
  });
  // setTimeout(() => {
  //   dispatch({
  //     type: LOGIN_NOTIFICATION,
  //     payload: "",
  //   });
  // }, 5000);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify(info);

  axios
    .post(`${configData.SERVER_URL}resetValidationPwd`, body, config)
    // .post("/api/auth", body, config)
    .then(
      (res) => {
        // console.log("pwt reset success success 0", res.data);
        dispatch({
          type: RESET_PWD_USER,
          payload: res.data,
        });
        // let history = useHistory();
        // history.push("/login");
        // dispatch({
        //   type: LOGIN_NOTIFICATION,
        //   payload: "Logged in.",
        // });
        // setTimeout(() => {
        //   dispatch({
        //     type: LOGIN_NOTIFICATION,
        //     payload: "",
        //   });
        // }, 2000);
      }
      // (CallGetElements())}
      // dispatch(getElements)
      // this.props.getElements()
    )
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.status);
        console.log(error.response.headers);
        console.log(error.response.data);
        dispatch({
          type: LOGIN_NOTIFICATION,
          payload: "",
        });
        dispatch({
          type: LOGIN_ERROR,
          payload: error.response.data.res,
        });
        setTimeout(() => {
          dispatch({
            type: LOGIN_ERROR,
            payload: "",
          });
        }, 5000);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

//Login User
// export const login = ({ email, password }) => dispatch => {
export const login =
  ({
    email,
    password,
    subdomain,
    accessToken = false,
    idToken = false,
    host = false,
    adminAccess = undefined,
  }) =>
  (dispatch) => {
    console.log("in login action", accessToken);
    // let propTypes = {
    //   getElements: PropTypes.func.isRequired
    // };

    // User loading
    // dispatch({ type: USER_LOADING });

    dispatch({
      type: LOGIN_NOTIFICATION,
      payload: "Loading...",
    });
    setTimeout(() => {
      dispatch({
        type: LOGIN_NOTIFICATION,
        payload: "",
      });
    }, 5000);

    // console.log("login");
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    //kdjfkd
    //create Request body
    const body = JSON.stringify({
      email,
      password,
      subdomain,
      accessToken,
      idToken,
      host,
      adminAccess,
    });

    console.log("login body", body);
    //javascript object and turn it into JSON
    // name email password are passed in by calling register
    axios
      .post(`${configData.SERVER_URL}auth`, body, config)
      // .post("/api/auth", body, config)
      .then(
        (res) => {
          // const ws = useContext(WebSocketContext);
          // static contextType = WebSocketContext

          // ws.setConnected(true);

          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          });
          // joinRoom();
          console.log("login success", res.data);
          //!!! only one dipatch possible

          // console.log("probl1");
          // dispatch({
          //   type: USER_UPDATED,
          //   payload: res.data.user,
          // });
          // console.log("probl2");
          // dispatch({
          //   type: LOGIN_NOTIFICATION,
          //   payload: "Logged in.",
          // });
          // setTimeout(() => {
          //   dispatch({
          //     type: LOGIN_NOTIFICATION,
          //     payload: "",
          //   });
          // }, 2000);
          // if (res.data.user)
          //   if (res.data.user.language) {
          //     console.log("login change language", res.data.user.language);
          //     i18n.changeLanguage(res.data.user.language);
          //   }
        }
        // (CallGetElements())}
        // dispatch(getElements)
        // this.props.getElements()
      )
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.status);
          console.log(error.response.headers);
          console.log(error.response.data);
          dispatch({
            type: LOGIN_NOTIFICATION,
            payload: "",
          });
          dispatch({
            type: LOGIN_ERROR,
            payload: error.response.data.res,
          });
          if (error.response)
            if (error.response.data)
              if (error.response.data.res)
                if (
                  !error.response.data.res.includes(
                    "User email is not validated yet."
                  )
                )
                  setTimeout(() => {
                    dispatch({
                      type: LOGIN_ERROR,
                      payload: "",
                    });
                  }, 5000);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  };

// const mapDispatchToProps = dispatch => ({
//   getElements
// });
// export default connect(null, mapDispatchToProps)(CallGetElements);
// const callGetElements = props => {
//   let propTypes = {
//     getElements: PropTypes.func.isRequired
//   };
//   getElements();
// };

// export default connect(null, {
//   getElements
// })(callGetElements);

// Logout User
export const logout = () => (dispatch) => {
  console.log("logout action called");
  dispatch({
    type: LOGOUT_SUCCESS,
  });
};

// Setup config/headers and token
export const tokenConfig = (getState) => {
  // Get token from localstorage
  const token = getState().auth.token; //if problem action call this not linked
  // console.log("new token", token);

  // Headers
  const config = {
    headers: {
      "Content-type": "application/json", // json data
    },
  };

  // If token, add to header
  if (token) {
    // console.log("token found");
    config.headers["x-auth-token"] = token;
  } else {
    console.log("no token found");
  }

  return config;
};

// Setup config/headers and token

export const wsTokenConfig = (getState) => {
  // Get token from localstorage
  const token = getState().auth.token; //if problem action call this not linked

  // If token, add to header
  if (token) {
    console.log("token found");
  } else {
    console.log("no token found");
  }

  return token;
};
